import React from 'react';
import { MenuIcon, BellIcon } from 'lucide-react';
interface HeaderProps {
  username?: string;
  onMenuClick: () => void;
  notificationCount?: number;
}
const Header = ({
  username = 'Usuario',
  onMenuClick,
  notificationCount = 0
}: HeaderProps) => {
  return <header className="bg-white shadow-sm px-4 py-3 flex items-center justify-between sticky top-0 z-10" data-id="element-21">
      <button onClick={onMenuClick} className="p-2 rounded-lg hover:bg-gray-100" aria-label="Menu" data-id="element-22">
        <MenuIcon size={24} data-id="element-23" />
      </button>
      <div className="text-sm font-medium text-gray-700" data-id="element-24">{username}</div>
      <div className="relative" data-id="element-25">
        <button className="p-2 rounded-lg hover:bg-gray-100" aria-label="Notificaciones" data-id="element-26">
          <BellIcon size={24} data-id="element-27" />
          {notificationCount > 0 && <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-28">
              {notificationCount}
            </span>}
        </button>
      </div>
    </header>;
};
export default Header;